import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'
import { useState } from 'react'

import type { FieldOrigin } from '../../uiModels/types'
import { HoverEditButton } from '../hoverEditGroup/HoverEditButton'
import { CopyInheritedValueModal } from './CopyInheritedValueModal'

type Props = {
  onCopy: () => void
  fromOrigin: FieldOrigin
  fieldPath: string
  hoverButtonClassName?: string
}

export const InheritedValueCopier = ({
  onCopy,
  fieldPath,
  fromOrigin,
  hoverButtonClassName,
}: Props) => {
  const [isCopyInheritedValueModalOpen, setIsCopyInheritedValueModalOpen] =
    useState(false)

  const handleCopyValue = () => {
    onCopy()
    setIsCopyInheritedValueModalOpen(false)
  }

  return (
    <>
      {isCopyInheritedValueModalOpen && (
        <CopyInheritedValueModal
          onCopyValue={handleCopyValue}
          path={fieldPath}
          fromOrigin={fromOrigin}
          onCancel={() => setIsCopyInheritedValueModalOpen(false)}
        />
      )}
      <div
        className={cx(
          'invisible absolute bottom-1 right-2 flex flex-row gap-x-2 group-hover:visible',
          hoverButtonClassName,
        )}
      >
        <HoverEditButton
          icon={<Icon name="ArrowDownTray" />}
          onClick={() => setIsCopyInheritedValueModalOpen(true)}
        />
      </div>
    </>
  )
}
